"use client"

import {
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
  Divider,
} from "@mui/material"
import { DollarSign, Briefcase } from "lucide-react"

const textColor = "#0d2561"
const itextColor = "#707070"

export function TotalFeeEarnedWidget() {
  const data = {
    totalFee: 75000,
    brokerFees: 45000,
    serviceProviderFees: 30000,
  }

  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1, fontSize:'1.20rem' }}>
          Total Fee Earned by Role
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 3 }}>
          Total fees earned (applies to brokers at 3% of accepted offer and service providers).
        </Typography>
        <Box display="flex" alignItems="center" gap={1}>
          <DollarSign className="h-5 w-5" color="#0d2561" width='20px' height='20px' />
          <Typography variant="h6" sx={{ color: "#0d2561",fontWeight:'bold' }}>
             ${data.totalFee.toLocaleString()}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" ml={4} mb={2}>
           Total Fees Earned
        </Typography>
         <Box display="flex" alignItems="center" gap={1}>
          <Briefcase className="h-5 w-5" color="#3b82f6" width='20px' height='20px' />
          <Typography variant="h6" sx={{ color: "#3b82f6",fontWeight:'bold' }}>
           ${data.brokerFees.toLocaleString()}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" ml={4} mb={2}>
            Broker Fees
        </Typography>
         <Box display="flex" alignItems="center" gap={1}>
          <Briefcase className="h-5 w-5" color="#a855f7" width='20px' height='20px' />
          <Typography variant="h6" sx={{ color: "#a855f7",fontWeight:'bold' }}>
              ${data.serviceProviderFees.toLocaleString()}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" ml={4} mb={25}>
           Service Provider Fees
        </Typography>

       
      </CardContent>
    </Card>
  )
}
